"use client";

import { useEffect } from "react";

import { onAnalyticsReady, pushStepEvent } from "@/app/utilities/analytics";

const BAC_LANDING_PAGE_INTENT = {
	event: "bac_consultant_intent",
	step: "2.1",
	stepName: "BAC Landing Page"
} as const;

export function VipLandingAnalytics() {
	useEffect(
		() => onAnalyticsReady(() => pushStepEvent(BAC_LANDING_PAGE_INTENT)),
		[]
	);

	return null;
}
